import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { loginInvitedUser } from '../../common/auth';
import { verifyEmailInvitation, verifyEmailRegistration } from '../../api/user';

function VerifyUserInvitation() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // User ID = uid
    const userId = searchParams.get('uid');
    // Magic Link Token = mlt
    const token = searchParams.get('mlt');
    // Org ID from search
    const orgId = Number(searchParams.get('orgId'));

    if (!userId || !token) {
      console.log('throw error as both are required');
      alert('Both user id and token are required to verify email login');
    } else {
      verifyEmailInvitation(Number(userId), token)
        .then((res) => {
          void loginInvitedUser(res.data, orgId);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, []);

  return (
    <>
      <h1>Verifying user invitation...</h1>
    </>
  );
}

export default VerifyUserInvitation;
